import { render, staticRenderFns } from "./result_orange.vue?vue&type=template&id=19ec7996&scoped=true"
import script from "./result_orange.vue?vue&type=script&lang=js"
export * from "./result_orange.vue?vue&type=script&lang=js"
import style0 from "./result_orange.vue?vue&type=style&index=0&id=19ec7996&prod&lang=scss&scoped=true"
import style1 from "./result_orange.vue?vue&type=style&index=1&id=19ec7996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec7996",
  null
  
)

export default component.exports